// slices/annualLeaveApiSlice.js
import { apiSlice } from './apiSlice';

export const annualLeaveApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // Preview calculation — does NOT write to DB
    previewAnnualLeave: builder.query({
      query: ({ startDate, endDate, userId }) => ({
        url: '/api/annual-leave/calculate',
        params: {
          startDate,
          endDate,
          ...(userId && { userId }),
        },
      }),
      providesTags: ['AnnualLeave'],
    }),

    // Apply calculation — writes newOpeningBalance to user records, never touches bringForward
    applyAnnualLeave: builder.mutation({
      query: ({ startDate, endDate, userIds = [] }) => ({
        url: '/api/annual-leave/apply',
        method: 'POST',
        body: { startDate, endDate, userIds },
      }),
      invalidatesTags: ['AnnualLeave', 'User'],
    }),

    // End of Year rollover — copies Opening Balance into Bring Forward and
    // resets Opening Balance to 0, for one staff member or (with no userIds)
    // every staff member in this calculator's staff categories.
    endOfYearAnnualLeave: builder.mutation({
      query: ({ userIds = [] } = {}) => ({
        url: '/api/annual-leave/end-of-year',
        method: 'POST',
        body: { userIds },
      }),
      invalidatesTags: ['AnnualLeave', 'User'],
    }),

    // Get leave config singleton
    getLeaveConfig: builder.query({
      query: () => '/api/annual-leave/config',
      providesTags: ['LeaveConfig'],
    }),

    // Update leave config
    updateLeaveConfig: builder.mutation({
      query: (data) => ({
        url: '/api/annual-leave/config',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['LeaveConfig'],
    }),
  }),
});

export const {
  usePreviewAnnualLeaveQuery,
  useLazyPreviewAnnualLeaveQuery,
  useApplyAnnualLeaveMutation,
  useEndOfYearAnnualLeaveMutation,
  useGetLeaveConfigQuery,
  useUpdateLeaveConfigMutation,
} = annualLeaveApiSlice;
